import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ResponseBase} from "../../data";
import {DeviceCommand} from "../../data/deviceCommand";

export interface DeviceCommandState {
    response: ResponseBase | null
    isLoading: boolean;
    error: ResponseBase | null;
    commands: DeviceCommand[];
}

const initialDeviceCommandState: DeviceCommandState = {
    isLoading: false,
    response: null,
    error: null,
    commands: [],
};

const deviceCommandSlice = createSlice({
    name: "deviceCommandSlice",
    initialState: initialDeviceCommandState,
    reducers: {
        setLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload;
        },
        setCommandList(state, action: PayloadAction<DeviceCommand[]>) {
            state.commands = action.payload;
            state.isLoading = false;
        },
        setResponse(state, action: PayloadAction<ResponseBase | null>) {
            state.response = action.payload;
            state.isLoading = false;
        },
        setError(state, action: PayloadAction<ResponseBase | null>) {
            state.isLoading = false;
            state.error = action.payload;
        }
    }
});

export const deviceCommandActions = deviceCommandSlice.actions;
export default deviceCommandSlice;
